import { Component, OnInit } from '@angular/core';
import { VerCasoUsoComponent } from '../ver-caso-uso.component';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  standalone:true,
  imports:[VerCasoUsoComponent,MatDialogModule],
  selector: 'app-dialog-view-caso-uso',
  templateUrl: './dialog-view-caso-uso.component.html',
  styleUrls: ['./dialog-view-caso-uso.component.css']
})
export class DialogViewCasoUsoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
